import { render, staticRenderFns } from "./PriceTypes.vue?vue&type=template&id=4f4a6374&scoped=true&"
import script from "./PriceTypes.vue?vue&type=script&lang=js&"
export * from "./PriceTypes.vue?vue&type=script&lang=js&"
import style0 from "./PriceTypes.vue?vue&type=style&index=0&id=4f4a6374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a6374",
  null
  
)

export default component.exports